import React, { Component, Fragment } from "react";
import api from "../../../../../services/api";
import unidadesSTI from "../../../../../constants/unidadesSTI";
import Select from "../../Relatorio1/Select";
import Radio from "../../Relatorio1/Radio";
import { Link } from "react-router-dom";

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import utils from "../../../../../utils/utilsProducaoSTI";
import AnualV2 from "../../Anual_v2";

export default class Relatorio4 extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Módulo de Metas",
            dados: {},
            mesSelecionado: "janeiro",
            isAcumulado: false,
            radioChecked: "mes"
        }
    }

    async componentDidMount() {
        await this.getDados();
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevState.isAcumulado !== this.state.isAcumulado) {
            await this.getDados();
        }
    }

    getDados = async (isAcumulado) => {

        let url = this.state.isAcumulado ? "/sti/consulta?tipo=acumulado" : "/sti/consulta?tipo=mes";
        let metas = await (await api.get("/sti/metas")).data.metas;
        this.setState({ metas });

    }

    selectMes = (event) => {
        this.setState({ mesSelecionado: event.target.value })
    }

    onChange = async (event) => {
        let isAcumulado = event.target.value === "acumulado" ? true : false;
        this.setState({ isAcumulado, radioChecked: event.target.value })
    }

    verificaValorTotalCategoria = (linhaAtuacao, valor) => {
        let valorTotalColuna = 0;
        if(valor.modalidades.hasOwnProperty(linhaAtuacao)) {
            if(linhaAtuacao === "Consultoria em Tecnologia") {
                valorTotalColuna = valor.modalidades[linhaAtuacao]["horasTecnicas"];
            }
            else if(linhaAtuacao === "Metrologia") {
                valorTotalColuna = null
            }
            else if(linhaAtuacao === "Pesquisa, Desenvolvimento e Inovação") {
                valorTotalColuna = valor.modalidades[linhaAtuacao]["horasTecnicas"];
            }
            else if(linhaAtuacao === "Serviços Técnicos Especializados") {
                valorTotalColuna = valor.modalidades[linhaAtuacao]["numeroAtendimento"];
            }
        }
        return valorTotalColuna;
    }

    // ************* Metas **************** //

    groupBy = (objectArray, property) => {
        return objectArray.reduce(function (acc, obj) {
            var key = obj[property];
            if (!acc[key]) {
            acc[key] = [];
            }
            acc[key].push(obj);
            return acc;
        }, {});
    }

    calculaMetas = () => {

        let { metas, dados } = this.state;
        if(!metas) return;
        let groupBySigla = this.groupBy(metas, "Sigla");

        // adiciona DR
        groupBySigla["DR"] = JSON.parse(JSON.stringify(metas));

        let vetor = [];

        Object.keys(groupBySigla).forEach(( sigla, ind1 ) => {
            
            // Agrupa por NomeNivel5
            let groupByNomeNivel5 = this.groupBy(groupBySigla[sigla], "NomeNivel5");
            // Agrupa por linhaAtuacao
            let groupByLinhaAtuacao = this.groupBy(groupBySigla[sigla], "linhaAtuacao");
            // concatena NomeNivel5 e linhaAtuacao
            groupByNomeNivel5 = { ...groupByNomeNivel5, ...groupByLinhaAtuacao }

            let objModalidades = {}
            
            Object.keys(groupByNomeNivel5).forEach(( categoria, ind2 ) => {

                let despesa           = new Array(12).fill(0);
                let ensaios           = new Array(12).fill(0);
                let horasTecnicas     = new Array(12).fill(0);
                let calibracoes       = new Array(12).fill(0);
                let numeroAtendimento = new Array(12).fill(0);
                let receita           = new Array(12).fill(0);
                let relatoriosELaudos = new Array(12).fill(0);
                
                groupByNomeNivel5[categoria].forEach((indicador, ind3 ) => {
                    indicador.despesa.forEach((valor, i)           => despesa[i] += valor );
                    indicador.ensaios.forEach((valor, i)           => ensaios[i] += valor );
                    indicador.horasTecnicas.forEach((valor, i)     => horasTecnicas[i] += valor );
                    indicador.calibracoes.forEach((valor, i)       => calibracoes[i] += valor );
                    indicador.numeroAtendimento.forEach((valor, i) => numeroAtendimento[i] += valor );
                    indicador.receita.forEach((valor, i)           => receita[i] += valor );
                    indicador.relatoriosELaudos.forEach((valor, i) => relatoriosELaudos[i] += valor );
                });

                objModalidades[categoria] = { despesa, ensaios, horasTecnicas, calibracoes, numeroAtendimento, receita, relatoriosELaudos }

            });
            
            sigla = unidadesSTI.parseNomeLongoSTI(sigla);

            vetor.push({
                unidade: sigla,
                modalidades: objModalidades
            });

        });
        
        return vetor;

    }

    formataNumero = (meta, modal, coluna, mes) => {
        
        try {
            let valor = meta.modalidades[modal][coluna][mes];
            return valor
        }
        catch(erro) {
            console.warn(">>>>>>>>>>>>>", erro, {meta, modal, coluna, mes})
            return 0;
        }

    }

    render() {

        let metas = this.calculaMetas();
        let { dados, mesSelecionado, radioChecked } = this.state;
        let linhaAtuacao = [
            "Consultoria em Tecnologia",
            "Metrologia",
            "Pesquisa, Desenvolvimento e Inovação",
            "Serviços Técnicos Especializados",
            "Serviços Complementares"
        ]


        let meses = ["janeiro", "fevereiro", "marco", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];
        return (
            <Fragment>

                <div class="card">
                    <div class="card-header">
                        Opções
                    </div>
                    <div class="card-body">

                        <Select selectMes={this.selectMes} selecionado={mesSelecionado} />
                        {/* <Radio onChange={this.onChange} radioChecked={radioChecked} /> */}
                        {/* <Link to={location => (
                            {
                                ...location,
                                pathname: `/upload`,
                                anterior: window.location.pathname || "/unidade",
                            }
                        )}>
                            <button className="btn btn-primary mt-3">Upload</button>
                        </Link> */}

                    </div>
                </div>

                <div className="mt-5">
                    <Tabs defaultActiveKey={"DR"} >

                        {metas && Object.keys(metas).map((nomeUnidade, i) => {

                            let valor = metas[nomeUnidade]
                            let sigla = valor.unidade;
                            let indice = metas.findIndex((nome) => nome.unidade === valor.unidade);
                            let meta = metas[indice];
                            
                            return (
                                <Tab eventKey={sigla} title={sigla}>
                                    
                                    <Fragment>
                                        <table border="1" className="table table-bordered table-hover table-sm table-striped">
                                            <thead>
                                                <tr>
                                                    <th colSpan="9" className="text-center">{valor.unidade}</th>
                                                </tr>
                                                <tr>
                                                    <th rowSpan="4">Áreas de Atuação</th>
                                                </tr>
                                                <tr>
                                                    <th colSpan="8" className="text-center">STI</th>
                                                </tr>
                                                <tr>
                                                    <th>Meta (<span style={{textTransform: "uppercase"}}>{mesSelecionado}</span>)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                
                                                { linhaAtuacao.map((linhaAtuacao, i) => {

                                                    let valorTotalColunaMeta = this.verificaValorTotalCategoria(linhaAtuacao, meta);
                                                    valorTotalColunaMeta = valorTotalColunaMeta ? utils.formataNumero(valorTotalColunaMeta[meses.indexOf(mesSelecionado)]) : 0
                                                    
                                                    return (

                                                        <Fragment>
                                                            <tr className="table caption-top table-primary">
                                                                <td className="text-center">{linhaAtuacao}</td>
                                                                <td>{linhaAtuacao === "Metrologia" ? null : valorTotalColunaMeta}</td>
                                                            </tr>
                                                            {Object.keys(valor.modalidades).map((modal, j) => {
                                                                let coluna = utils.verificaColuna(modal);

                                                                if(utils.retornaCabecalho(modal) === linhaAtuacao) {
                                                                    return (
                                                                        <Fragment>
                                                                            <tr>
                                                                                <td>{modal}</td>
                                                                                <td>{this.formataNumero(meta, modal, coluna, meses.indexOf(mesSelecionado))}</td>
                                                                            </tr>
                                                                            {
                                                                                modal === "Ensaios" 
                                                                                ?
                                                                                <tr>
                                                                                    <td>{"Relatórios/Laudos"}</td>
                                                                                    <td>{this.formataNumero(meta, modal, "relatoriosELaudos", meses.indexOf(mesSelecionado))}</td>
                                                                                </tr>
                                                                                :
                                                                                null
                                                                            }
                                                                            {
                                                                                modal === "Calibração"
                                                                                ?
                                                                                <tr>
                                                                                    <td>{"Relatórios/Laudos"}</td>
                                                                                    <td>{this.formataNumero(meta, modal, "relatoriosELaudos", meses.indexOf(mesSelecionado))}</td>
                                                                                </tr>
                                                                                :
                                                                                null
                                                                            }
                                                                        </Fragment>
                                                                    )
                                                                }
                                                                
                                                            })}
                                                        </Fragment>

                                                    )
                                                    
                                                }) }
                                            
                                            </tbody>
                                        </table>

                                        <AnualV2 unidade={sigla} metas={metas} />
                                        
                                    </Fragment>

                                </Tab>
                            )
                        })}

                    </Tabs>
                </div>

            </Fragment>
        )
    }
}